<template>
  <transition name="fade">
    <div v-if="show" id="goTop" @click="goTop" class="tranEase">
      <div class="mx-2 font1.5" >
        <i class="fas fa-arrow-up"></i>
      </div>
    </div>
  </transition>
</template>

<script>
	export default {
		name: "AppGoTop",
		data() {
			return {
				show: false,
        target: null
			}
		},
		methods: {
			goTop() {
				console.log('goo')
				this.$scrollToTop()
			},
			go_top_status() {
				if (this.target.scrollTop > screen.height / 2)
					this.show = true
				else
					this.show = false
			}
		},
		mounted() {
			this.target = document.getElementById("main-panel")
			this.go_top_status()
 			this.target.addEventListener("scroll", this.go_top_status, false)
		},
		destroyed() {
			this.target.removeEventListener("scroll", this.go_top_status, false)
		},

	}
</script>
<style lang="scss">
  #goTop {
    position: fixed;
    bottom: 30px;
    left: 30px;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f15b3a;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    @media (max-width: 576px) {
      bottom: 10px;
      left: 0px;
    }


  }
</style>
